<template>
  <div class="fixed" style="z-index: 202">
    <transition name="contact-ltr">
      <div
        v-if="!firstStep"
        class="absolute screen pt-12.5 pl-82.5 pr-17.25 h-screen w-screen"
        :style="'top: ' + (slide - 1) + '00vh'"
      >
        <contactFirst
          :text="text.first"
          @nextStage="nextStep($event)"
        />
      </div>
      <div
        v-else
        class="absolute screen pt-12.5 pl-82.5 pr-17.25 h-screen w-screen"
        :style="'top: ' + (slide - 1) + '00vh'"
      >
        <contactSecond
          :text="text.second"
          :choice="choice"
        />
      </div>
    </transition>
  </div>
</template>

<script>
import contactFirst from "./contactFirst";
import contactSecond from "./contactSecond";
import {mapState} from "vuex";

export default {
  name: "contact",
  props: ["slide"],
  components: { contactFirst, contactSecond },
  data() {
    return {
      firstStep: false,
      choice: "",
    };
  },
  methods: {
    nextStep(e) {
      this.choice = e;
      this.firstStep = true;
    },
  },
  computed: {
    text() {
      return require("@/assets/text/contact/" + this.lang + ".json");
    },
    ...mapState(['lang'])
  },
};
</script>

<style lang="scss">
.screen {
  background: #323749;
  left: 0;
}

.contact-ltr-enter-active,
.contact-ltr-leave-active {
  transition: all 0.3s linear;
}
.contact-ltr-enter-from {
  left: 100vw;
}
.contact-ltr-leave-to {
  left: -100vw;
}
</style>
